module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-2021-3-v2.1ada08d1.jpg";